const RESOURCES = {
  USER_CODE: {
    it: {
      label: 'Inserisci il tuo codice sella.it',
      placeholder: 'Codice sella.it'
    },
    en: {
      label: 'Insert your sella.it code',
      placeholder: 'Sella.it code'
    }
  },
  USER_PIN: {
    it: {
      label: 'Inserisci il tuo pin',
      placeholder: 'Pin'
    },
    en: {
      label: 'Insert your pin',
      placeholder: 'Pin'
    }
  },
  DATE_OF_BIRTH: {
    it: {
      label: 'Inserisci la tua data di nascita',
      placeholder: 'dd/MM/yyyy'
    },
    en: {
      label: 'Insert yout birth date',
      placeholder: 'dd/MM/yyyy'
    }
  },
  INSERT_TWO_PWD_CHARS: {
    it: {
      value: 'Inserisci i due caratteri della password richiesti'
    },
    en: {
      value: 'Enter the requested two password chars'
    }
  },
  PWD_CHARS: {
    it: {
      label: '%d&deg; e %d&deg; carattere',
      placeholder: '%d° e %d° carattere'
    },
    en: {
      label: 'chars n.%d and n.%d',
      placeholder: 'chars n.%d and n.%d'
    }
  },
  INSERT_RSA_OTP: {
    it: {
      label: 'Inserici il codice RSA OTP',
      placeholder: 'RSA OTP'
    },
    en: {
      label: 'Enter RSA OTP Code',
      placeholder: 'RSA OTP'
    }
  },
  INSERT_NEXT_RSA_OTP: {
    it: {
      label: 'Inserici il codice RSA OTP successivo',
      placeholder: 'RSA OTP'
    },
    en: {
      label: 'Enter the next RSA OTP Code',
      placeholder: 'RSA OTP'
    }
  },
  REINSERT_RSA_OTP: {
    it: {
      label: 'Reinserici il codice RSA OTP',
      placeholder: 'RSA OTP'
    },
    en: {
      label: 'Re-enter RSA OTP Code',
      placeholder: 'RSA OTP'
    }
  },
  WARN_REINSERT_CREDENTIALS: {
    it: {
      value: 'Reinserisci le tue credenziali'
    },
    en: {
      value: 'Reinsert your credentials'
    }
  },
  INFO_CORRECT_OTP_REINSERT_NEXT_OTP: {
    it: {
      value:
        'OTP corretto, a causa di errori precedenti ti chiediamo di inserire anche il codice RSA OTP successivo'
    },
    en: {
      value:
        'Correct OTP, due to previous OTP errors, please enter Next RSA OTP Code'
    }
  },
  WRONG_OTP: {
    it: {
      value: 'OTP errato!'
    },
    en: {
      value: 'Wrong OTP!'
    }
  },
  ERROR_PASSWORD_EXPIRED: {
    it: {
      value: 'Password scaduta.'
    },
    en: {
      value: 'Password expired'
    }
  },
  ERROR_PIN_EXPIRED: {
    it: {
      value: 'PIN scaduto.'
    },
    en: {
      value: 'PIN expired'
    }
  },
  WARN_PASSWORD_REMINDER: {
    it: {
      value: 'La tua password scadrà tra %d %g.'
    },
    en: {
      value: 'Your password is about to expire in %d %g.'
    }
  },
  WARN_PIN_REMINDER: {
    it: {
      value: 'Il tuo PIN scadrà tra %d %g.'
    },
    en: {
      value: 'Your PIN is about to expire in %d %g.'
    }
  },
  G: {
    it: {
      value: 'giorno'
    },
    en: {
      value: 'day'
    }
  },
  GG: {
    it: {
      value: 'giorni'
    },
    en: {
      value: 'days'
    }
  },
  MESSAGE_TYPE_0: {
    it: {
      value: 'Info'
    },
    en: {
      value: 'Info'
    }
  },
  MESSAGE_TYPE_1: {
    it: {
      value: 'Attenzione'
    },
    en: {
      value: 'Warning'
    }
  },
  MESSAGE_TYPE_2: {
    it: {
      value: 'Errore'
    },
    en: {
      value: 'Error'
    }
  }
}

//@todo add the translation for `Dear colleague,<BR/>We got a system error during Authentication process!!` and other generic error messages not bound to a code

export const getResource = (key, lang, property) => {
  try {
    if (!property) {
      property = 'value'
    }

    if (key.indexOf('PWD_CHARS:') > -1) {
      const tmp = key.split(':')
      const newKey = tmp[0]
      const values = tmp[1].split(',')

      const res = RESOURCES[newKey][lang][property]

      return res.replace(/%d/, values[0]).replace(/%d/, values[1])
    } else if (key.indexOf('WARN_PASSWORD_REMINDER:') > -1) {
      const s = key.split(':')
      const k = s[0]
      const numd = s[1]
      let days = ''
      if (numd >= 1) {
        const _rgg = 'GG'
        days = RESOURCES[_rgg][lang][property]
      } else {
        const _rg = 'G'
        days = RESOURCES[_rg][lang][property]
      }

      const r = RESOURCES[k][lang][property]

      return r.replace(/%d/, numd).replace(/%g/, days)
    } else if (key.indexOf('WARN_PIN_REMINDER:') > -1) {
      const s1 = key.split(':')
      const k1 = s1[0]
      const numd1 = s1[1]
      let days1 = ''
      if (numd1 >= 1) {
        const _rgg1 = 'GG'
        days1 = RESOURCES[_rgg1][lang][property]
      } else {
        const _rg1 = 'G'
        days1 = RESOURCES[_rg1][lang][property]
      }

      const r1 = RESOURCES[k1][lang][property]

      return r1.replace(/%d/, numd1).replace(/%g/, days1)
    } else {
      return RESOURCES[key][lang][property]
    }
  } catch (ex) {
    // @log missing resource for key: ' + key + ', lang: ' + lang
    return key
  }
}



// WEBPACK FOOTER //
// ./state/authLocale.js